import { useEffect, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useMsal } from "@azure/msal-react";
import useReqRequests from "../utils/helpers/helperMethods/userRequets";
import {
  getAllLeads,
  getHotLeads,
  getWarmLeads,
  getInterestedLeads,
  getLeadCount,
} from "../slices/leads/leadManagementSlice";
import { AppDispatch, RootState } from "../slices/store";
import UseAuthConfig from "./useAuthConfig";
import { scrollToTop } from "../utils/helpers/helperMethods/scrollToTop";

const useFetchLeads = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { instance } = useMsal();
  const { protectedResources }: any = UseAuthConfig();
  const { reqRequests } = useReqRequests();
  const [hasFetched, setHasFetched] = useState(false);

  const { allLeads, hotLeads, warmLeads, interestedLeads, leadCount, status } =
    useSelector((state: RootState) => state.leadsManagement);

  const fetchLeads = useCallback(
    async (type?: string) => {
      try {
        const tokenResponse = await instance.acquireTokenSilent({
          scopes: protectedResources.apiTodoList.scopes.write,
        });
        const token = tokenResponse.accessToken;

        if (!allLeads?.succeeded) {
          dispatch(getAllLeads({ ...reqRequests, accessToken: token }));
        }
        if (!hotLeads?.succeeded) {
          dispatch(
            getHotLeads({
              ...reqRequests,
              leadType: "HighIntent",
              accessToken: token,
            })
          );
        }
        if (!warmLeads?.succeeded) {
          dispatch(
            getWarmLeads({
              ...reqRequests,
              leadType: "MediumIntent",
              accessToken: token,
            })
          );
        }
        if (!interestedLeads?.succeeded) {
          dispatch(
            getInterestedLeads({
              ...reqRequests,
              leadType: "LowIntent",
              accessToken: token,
            })
          );
        }
        if (!leadCount?.succeeded) {
          dispatch(
            getLeadCount({
              ...reqRequests,
              accessToken: token,
              type: type || "Date",
            })
          );
        }
        setHasFetched(true);
      } catch (error) {
        console.error("Error fetching leads:", error);
      }
    },
    [
      allLeads?.succeeded,
      hotLeads?.succeeded,
      warmLeads?.succeeded,
      interestedLeads?.succeeded,
      leadCount?.succeeded,
      dispatch,
      instance,
      protectedResources.apiTodoList.scopes.write,
      reqRequests,
    ]
  );

  useEffect(() => {
    if (!hasFetched) {
      fetchLeads();
      scrollToTop();
    }
  }, [fetchLeads, hasFetched]);

  return {
    allLeads,
    hotLeads,
    warmLeads,
    interestedLeads,
    leadCount,
    status,
    fetchLeads,
  };
};

export default useFetchLeads;
